import React, { Fragment, useContext } from "react";
import { RulesContext } from "../../../RulesContext";
import isEmpty from "lodash/isEmpty";
import Bootbox from "../../../../../../Common/BootBoxManager";
import MatrixTable from "./MatrixTable";
import TableSkeletonElement from "Components/GMS/Products/components/TableSkeletonElement";

const MatrixComponent = () => {
  const { ruleDispatch, CBMOptions, setCBMOptions, Loading, setCompatibilityData, setCellStates } = useContext(RulesContext);
  const dispatch = ruleDispatch;

  const { leftCatListOption, rightCatListOption, leftCatAttributeSet, rightCatAttributeSet, leftCatProductList, rightCatProductList, showWarninModal, valueToBeSaved, leftAttributeValues, rightAttributeValues } = CBMOptions;

  const setCompatibilityLevel = () => {
    setCBMOptions((prevState) => {
      return {
        ...prevState,
        compatibilityLevel: valueToBeSaved,
        showWarninModal: false,
      };
    });

    resetMatrixValues();
    closeWarningModal();
  };

  const closeWarningModal = () => {
    setCBMOptions((prevState) => {
      return {
        ...prevState,
        showWarninModal: false,
      };
    });
  };

  const resetMatrixValues = () => {
    setCompatibilityData([]);
    setCellStates({});
    setCBMOptions((prevState) => {
      return {
        ...prevState,
        defaultCompatibilityValue: "",
      };
    });
    dispatch({ type: "CBM_RULE_TYPE", data: [] });
  };

  return (
    <Fragment>
      <div className="cbm-container" id="cbm-container">
        {Loading.status === "Loading" && <TableSkeletonElement />}
        {Loading.status !== "Loading" && leftCatListOption && rightCatListOption &&
          (
            (leftCatListOption === "products" && (isEmpty(leftCatProductList) || isEmpty(rightCatProductList))) ||
            (leftCatListOption === "values" && (isEmpty(leftAttributeValues) || isEmpty(rightAttributeValues)))
          ) && (
            <div>No Data to Show</div>
          )}
        {Loading.status !== "Loading" &&
          (
            (leftCatListOption === "products" && !isEmpty(leftCatProductList) && !isEmpty(rightCatProductList)) ||
            (leftCatListOption === "values" && !isEmpty(leftAttributeValues) && !isEmpty(leftAttributeValues))
          ) && (
            <>
              <MatrixTable />
            </>
          )}
        {showWarninModal &&
          Bootbox.confirm(
            "ChangeRating Level?",
            `Changing the level will reset the product matrix data to default value.`,
            false,
            [setCompatibilityLevel]
          )}
      </div>
    </Fragment>
  );
};
export default MatrixComponent;